import { render, staticRenderFns } from "./SingleCard.vue?vue&type=template&id=60a65871"
import script from "./SingleCard.vue?vue&type=script&lang=js"
export * from "./SingleCard.vue?vue&type=script&lang=js"
import style0 from "./SingleCard.vue?vue&type=style&index=0&id=60a65871&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports